import { NavigationCard } from "@/components/navigation-card";

export function GenerateGameCard() {
  return (
    <NavigationCard
      title="Generate a Game"
      splash="https://images.unsplash.com/photo-1605870445919-838d190e8e1b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NDM2NzN8MHwxfHNlYXJjaHwyfHxkaWNlfGVufDB8MHx8fDE3NDU1MjIzNzh8MA&ixlib=rb-4.0.3&q=80&w=200"
      description="Generate a random game based off of your preferences."
      to="/game-generator"
    />
  );
}
